import { Controller } from "@hotwired/stimulus"

// Generyczne przełączanie zakładek "pełnych stron" (np. /account/menu, /profile/accounts).
// Obie treści są w DOM od razu (lekkie), więc przełączamy tylko widoczność paneli
// i styl przycisków - bez pobierania w tle. Stan startowy ustawia HTML (pierwszy panel
// widoczny, pierwszy przycisk aktywny). Rejestrowany globalnie w controllers/index.js.
export default class extends Controller {
  static targets = ["panel", "btn"]

  switch(event) {
    const selected = event.currentTarget.dataset.tab

    this.panelTargets.forEach(panel => {
      panel.classList.toggle("hidden", panel.dataset.tab !== selected)
    })

    this.btnTargets.forEach(btn => {
      const active = btn.dataset.tab === selected
      btn.classList.toggle("text-gray-900", active)
      btn.classList.toggle("font-semibold", active)
      btn.classList.toggle("border-blue-500", active)
      btn.classList.toggle("text-gray-400", !active)
      btn.classList.toggle("font-medium", !active)
      btn.classList.toggle("border-transparent", !active)
    })
  }
}
